import styled from "styled-components";
import { device } from "../globalAssets/breakpoints";
import { desktop } from "../globalAssets/fontsize";

interface DropDownType {
  onChange?: React.ChangeEventHandler<HTMLSelectElement>;
  values?: any;
  required?: boolean;
  placeholder?: string;
}

export const DropDown: React.FC<DropDownType> = ({
  onChange,
  values,
  required,
  placeholder,
}) => {
  return (
    <InputDiv>
      <Dropdown
        placeholder={placeholder}
        required={required ? true : false}
        onChange={onChange}
      >
        <Option value="">Select a country</Option>
        {values?.map((value: any) => (
          <Option
            // defaultValue={values[1].label}
            key={value.value}
            value={value.label}
          >
            {value.label}
          </Option>
        ))}
      </Dropdown>
    </InputDiv>
  );
};

const Dropdown = styled.select`
  &&& {
    border: none;
    background: ${(props) => props.theme.foreground};
    width: 100%;
    padding: 5px 10px;
    outline: none;
    height: 100%;
    color: ${(props) => props.theme.color};
    font-size: 14px !important;

    @media ${device.laptop} {
      /* background-color: re; */
      font-size: ${desktop.small} !important;
      /* height: 2.5vw; */
      cursor: pointer;
      &:focus,
      &:active {
        font-size: ${desktop.small};
        outline: none;
        border: none;
      }
    }
  }
`;

// const IconContainer = styled.div`
//   font-size: 1.2vw;
//   margin: 0;
//   color: ${theme.grey};
//   display: flex;
//   align-items: center;
// `;

const Option = styled.option`
  background-color: ${(props) => props.theme.foreground} !important;
  font-size: 14px !important;
  @media ${device.laptop} {
    font-size: ${desktop.small} !important;
  }
`;

const InputDiv = styled.div`
  width: 100%;
  height: 40px;
  border: 1px solid ${(props) => props.theme.subtleBlack};
  border-radius: 4px;
  padding: 0vw 0vw;
  :active,
  :focus,
  :hover {
    border: 2px solid ${(props) => props.theme.primaryColor};
  }
  @media ${device.laptop} {
    height: 2.5vw;
    :active,
    :focus,
    :hover {
      border: 1px solid ${(props) => props.theme.primaryColor};
    }
  }
`;
